export default __webpack_public_path__ + "static/media/sportsCommunityBadgeSample.6ce574c4.png";